import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../App";
import { Loader2, CheckCircle } from "lucide-react";

// If someone navigates directly to /login, auto-open the sign-in modal
// and redirect to dashboard after success — no separate login page needed.
const Login = () => {
  const { login, user, loading } = useAuth();
  const navigate = useNavigate();
  const calledRef = useRef(false);

  // Auto-open sign-in modal once auth state is known
  useEffect(() => {
    if (!loading && !user && !calledRef.current) {
      calledRef.current = true;
      const redirect = localStorage.getItem('transplacement_redirect') || '/dashboard';
      login(redirect);
    }
  }, [loading, user, login]);

  // Redirect away once signed in
  useEffect(() => {
    if (user && !loading) {
      const redirect = localStorage.getItem('transplacement_redirect') || '/dashboard';
      localStorage.removeItem('transplacement_redirect');
      navigate(redirect, { replace: true });
    }
  }, [user, loading, navigate]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (user) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <CheckCircle className="h-12 w-12 mx-auto text-green-500" />
          <p className="text-foreground font-medium mt-4">You're signed in!</p>
          <p className="text-muted-foreground text-sm mt-1">Redirecting...</p>
        </div>
      </div>
    );
  }

  // Blank while modal is open
  return <div className="min-h-screen bg-background" />;
};

export default Login;
